import moment from "moment";

export function sortByNumberOrString(a, b) {
  try {
    const _a = a ?? "";
    const _b = b ?? "";
    const intA = parseInt(a);
    const intB = parseInt(b);

    //fall back on string comparison if we can't
    if (Number.isNaN(intA) || Number.isNaN(intB)) {
      return _a.toString().localeCompare(_b.toString());
    }

    return intA - intB;
  } catch (e) {
    return 0;
  }
}

export function sortByDate(a, b) {
  if (!a && b) {
    return -1;
  } else if (!b && a) {
    return 1;
  }
  if(a === b) return 0;
  const distantFuture = moment(8640000000000000);
  try {
    // Parse dates using moment.js and compare
    const dateA = moment(a);
    const dateB = moment(b);

    const validDateA = dateA.year() > 2020 ? dateA : distantFuture;
    const validDateB = dateB.year() > 2020 ? dateB : distantFuture;

    return validDateA.diff(validDateB);
  } catch (e) {
    return 0;
  }
}
